module.exports = __webpack_public_path__ + "img/gerb.56873768.svg";